module.exports = __webpack_public_path__ + "img/Big_Arts_Yokel@3x.e5fa2c2e.webp";